import { address, error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const fetchCardReviewDetails = gql`
  query FetchCardReviewDetails($cardId: ID!, $cardAction: CardCtaAction) {
    cardReviewDetails(cardId: $cardId, cardAction: $cardAction) {
      __typename
      ... on CardReviewDetailsSuccess {
        __typename
        review {
          __typename
          id
          description
          title
        }
        address {
          __typename
          id
          title
          address {
            ...address
          }
        }
        arrival {
          __typename
          id
          title
          description
        }
        ctaAction {
          __typename
          copy
          ... on CardAction {
            __typename
            action
            type
          }
        }
        cardLockedInfo {
          id
          title
          description
        }
      }
      ... on CardReviewDetailsError {
        __typename
        ...error
      }
    }
  }
  ${address}
  ${error}
`;

export default fetchCardReviewDetails;
